// Core component styles
const coreStyles={container:{display:'flex',flexShrink:0}};/**
 * Helper method to get the styles for Activity Indicator component
 * @param {Object} contextStyles - Context styles for Activity Indicator Component
 */const getStyles=function(){let contextStyles=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};return{container:{...coreStyles.container,...contextStyles.container}};};export default getStyles;